export function parseInfoParagraphBody(body: string | undefined): {
  intro: string | null;
  listItems: string[];
} {
  if (!body) {
    return { intro: null, listItems: [] };
  }

  const lines = body
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length <= 1) {
    return { intro: lines[0] ?? null, listItems: [] };
  }

  return {
    intro: lines[0],
    listItems: lines.slice(1).map((line) => line.replace(/^-\s*/, "")),
  };
}
